import { useTranslation } from '@/contexts/i18n-context';
import { useEncounter } from '@/contexts/encounter-context';
import { DataRow, ExpandableInfo } from '@/components/encounter/review/expandable-info';
import { useGetEncountersPayment } from '@/api/get-payment-info';
import { Loader } from '../loaders/loader';
import { formatPrice } from '@/util/formats';

const translationBase = 'visit.review';
const translationBasePayment = `${translationBase}.payment`;

export function PaymentSection() {
  const { t } = useTranslation();
  const { encounter } = useEncounter();
  const { data: paymentInfo, isFetching, error } = useGetEncountersPayment(encounter.id);

  const orderSummary = paymentInfo?.pricePaid
    ? t(`${translationBasePayment}.orderSummaryText`, {
        price: formatPrice(paymentInfo.pricePaid),
      })
    : t(`${translationBasePayment}.orderSummaryTextFree`);

  return (
    <>
      {isFetching && <Loader type="small" />}
      {error && <p>{t(`${translationBasePayment}.error`)}</p>}
      {paymentInfo && (
        <ExpandableInfo title={t(`${translationBasePayment}.title`)}>
          <DataRow title={t(`${translationBasePayment}.priceOfVisit`)}>
            {formatPrice(paymentInfo.baseAmount)}
          </DataRow>
          <DataRow title={t(`${translationBasePayment}.paidByPatient`)}>
            {formatPrice(paymentInfo.pricePaid ?? 0)}
          </DataRow>
          <DataRow title={t(`${translationBasePayment}.confirmationNumber`)}>
            {paymentInfo.confirmationNumber ?? t(`${translationBase}.na`)}
          </DataRow>
          <DataRow title={t(`${translationBasePayment}.orderSummary`)}>{orderSummary}</DataRow>
        </ExpandableInfo>
      )}
    </>
  );
}
